import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import { Show } from "../../../actions/SnackbarActions";
import { Post } from "../../../utils/request";
import ConfigCourse from "./FormBody/index.js";
import SweetAlert from "react-bootstrap-sweetalert";
import HourglassBottomIcon from "@mui/icons-material/HourglassBottom";
import CheckIcon from "@mui/icons-material/Check";
import SaveIcon from "@mui/icons-material/Save";
import { removeHTML } from "utils/filters";

const CourseAdd = () => {
  const [popup, SetPopup] = useState(false);
  const [popupMessage, SetPopupMessage] = useState("");

  const [loading, SetLoading] = useState(false);

  const userId = useSelector((store) => store.AppReducer.user?.id);

  const dispatch = useDispatch();
  const history = useHistory();

  const [save_button_status, setSaveButtonStatus] = useState({
    status: "Salvar tudo",
    icon: <SaveIcon />,
  });

  const Submit = async (data) => {
    if (!data?.image) {
      SetPopup(true);
      SetPopupMessage("Insira uma imagem");
      return;
    } else if (!data?.name) {
      SetPopup(true);
      SetPopupMessage("Insira um nome!");
      return;
    } else if (!data?.description && !data?.section5_use_image) {
      SetPopup(true);
      SetPopupMessage("Insira uma descrição!");
      return;
    } else if (data?.section5_use_image && !data?.section5_image) {
      SetPopup(true);
      SetPopupMessage("Insira uma imagem para a seção 5!");
      return;
    } else if (data?.responsibles.length == 0) {
      SetPopup(true);
      SetPopupMessage("Insira pelo menos um responsável pelo curso!");
      return;
    } else if (data?.categories.length == 0) {
      SetPopup(true);
      SetPopupMessage("Insira uma categoria!");
      return;
    } else if (
      data?.price === null ||
      data?.price === "" ||
      data?.price === undefined
    ) {
      data.price = 0;
    } else if (
      data?.installments_price === null ||
      data?.installments_price === "" ||
      data?.installments_price === undefined
    ) {
      data.installments_price = 0;
    }

    const shouldValidateTitle = (key) => {
      if (key === "section2_title") return data.show_section2 && !data.section2_use_image;
      if (key === "section3_title") return data.show_section3 && !data.section3_use_image;
      if (key === "section4_title") return data.show_section4 && !data.section4_use_image;
      if (key === "temp_section5_title")
        return data.temp_show_section5 && !data.temp_section5_use_image;
      if (key === "warranty_title") return data.show_warranty && !data.warranty_use_image;
      return true;
    };

    for (const k in data) {
      const key = k.toLocaleLowerCase();
      if (key.includes("title") && shouldValidateTitle(k)) {
        if (removeHTML(data[k]) === "") {
          SetPopup(true);
          SetPopupMessage("Preencha todos os campos obrigatórios!");
          return;
        }
      }
    }
    let form = new FormData();
    for (const key in data) {
      if (data[key] === null) {
        form.append(key, "");
      } else {
        form.append(key, data[key]);
      }
    }

    form.append(
      "video_trailer",
      data?.videoTrailer[0] == undefined ? "" : data?.videoTrailer[0]
    );

    for (let i = 0; i < data.responsibles.length; i++)
      form.append("responsible_id[]", data.responsibles[i]?.id);
    for (let i = 0; i < data.categories.length; i++)
      form.append("category_id[]", data.categories[i]?.id);
    for (let i = 0; i < data.tags.length; i++)
      form.append("tag_id[]", data.tags[i]?.id);

    for (const item of data.whatWillLearn) {
      if (item.text !== "") {
        form.append("what_will_learn[]", JSON.stringify(item));
      }
    }

    let new_what_will_get = [];
    data.whatWillGet.filter((item) => {
      if (item.title !== "" && item.text !== "") {
        new_what_will_get.push(item);
      }
    });

    for (const item of new_what_will_get) {
      if (item.title !== "" && item.text !== "") {
        form.append("whatWillGet[]", JSON.stringify(item));
      }
    }

    if (new_what_will_get.length === 0) {
      form.delete("whatWillGet");
    }

    for (const item of data.questions) {
      if (item.question !== "" && item.answer !== "") {
        form.append("questions[]", JSON.stringify(item));
      }
    }

    for (const item of data.opcells) {
      // form.append("opcells[]", JSON.stringify(item));
      form.append("opcells[]", JSON.stringify({id:item.id,price:item.price}));

    }

    SetLoading(true);
    setSaveButtonStatus({
      status: "Salvando...",
      icon: <HourglassBottomIcon />,
    });

    let response = await Post("courses-main/create", form);
    SetLoading(false);

    if (response["errors"] !== undefined) {
      let errors = Object.values(response.errors);
      let erro = "";
      for (let i = 0; i < errors.length; i++) {
        if (i != errors.length - 1) erro += errors[i] + "\n";
        else erro += errors[i];
        break;
      }
      console.log(erro);
      SetPopup(true);
      SetPopupMessage(erro);
      setSaveButtonStatus({
        status: "Salvar tudo",
        icon: <SaveIcon />,
      });
      return;
    }

    if (response.status === false) {
      SetPopup(true);
      SetPopupMessage(response.message);
      setSaveButtonStatus({
        status: "Salvar tudo",
        icon: <SaveIcon />,
      });
      return;
    }

    if (response["success"] !== undefined) {
      setSaveButtonStatus({
        status: "Salvo!",
        icon: <CheckIcon />,
      });
    }

    setTimeout(() => {
      setSaveButtonStatus({
        status: "Salvar tudo",
        icon: <SaveIcon />,
      });
    }, 2000);

    dispatch(
      Show({
        show: true,
        message: response?.message,
        severity: response?.severity,
        buttonActionText: "Ver",
        ButtonAction: () => history.push(`/courses/view/${response?.courseId}`),
      })
    );

    if (response?.status === true) history.push("/courses/list");
  };

  return (
    <div className="card">
      <SweetAlert
        warning
        show={popup}
        title="Atenção!"
        confirmBtnText="Ok"
        onConfirm={() => SetPopup(false)}
      >
        {popupMessage}
      </SweetAlert>
      <div className="card-body">
        <ConfigCourse
          OnConfirm={(data) => Submit(data)}
          loading={loading}
          {...{ save_button_status }}
        />
      </div>
    </div>
  );
};

export default CourseAdd;
